import { Box, Grid, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { PositionBadge } from "src/components/CrewSchedule/PositionBadge";
import { IContentCellProps } from "src/pages/FlightStatus/FlightStatusWindow";

export function CrewApp(props: IContentCellProps): JSX.Element {
  const { data } = props;
  const theme = useTheme();
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        p: 1,
        borderBottom: `6px solid ${data.accepted ? theme.palette.success.dark : theme.palette.warning.dark}`,
        width: "100%",
        height: "100%",
      })}
    >
      <Grid container spacing={0} sx={{ flexGrow: 1 }}>
        <Grid item xs={"auto"} sx={{ pr: 2 }}>
          {data.accepted && <CheckCircleIcon />}
          {data.accepted !== true && <WarningIcon />}
        </Grid>
        <Grid item xs>
          {data.devices &&
            Object.values(data.devices)
              .sort((a: any, b: any) => {
                if (a.pairPosOrder !== b.pairPosOrder) {
                  return a.pairPosOrder - b.pairPosOrder;
                }
                return a.hireDate - b.hireDate;
              })
              .map((device: any, key: number) => {
                return (
                  <Box key={key} sx={{ display: "inline-flex", textWrap: "nowrap" }}>
                    <PositionBadge
                      positionTitle={device.pairPosition}
                      filled
                      bgColor={device.connected ? theme.palette.success.dark : theme.palette.error.dark}
                    />
                    {device.preferredName !== "" ? device.preferredName : device.firstName} {device.lastName}
                  </Box>
                );
              })}
        </Grid>
      </Grid>
    </Box>
  );
}
